import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import Moment from 'moment';
import SweetAlert from 'sweetalert-react';
import * as UserActions from '../../../actions/userActions';
import {calculateAge} from '../../../utils/utils';
import Loader from '../../../components/commons/loader/loader';
import * as User from '../../../utils/userHelpers';
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';
import {
  FacebookLoginButton,
  GoogleLoginButton
} from "react-social-login-buttons";

import * as FBinit from '../../../utils/fbintit';
import * as GoogleInit from '../../../utils/googleOauth';
class SignupPage extends Component {

  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      
      signupData: {
        lastName: '',
        firstName: '',
        email: '',
        phone: '',
        password1: '',
        password2: '',
        dob: ''
      },
      show: false,
      invalid: true,
      error: '',
      showAlert: false,
      swalParams: {
        title: ''
      },
      customClass:""
    }

    this.signup = this.signup.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    this.checkValidation = this.checkValidation.bind(this);
    this.handlePhoneChange = this.handlePhoneChange.bind(this);
    this.checkOtp = this.checkOtp.bind(this);
    this.resendOTP=this.resendOTP.bind(this);
    this.signupFB = this.signupFB.bind(this);
    this.signupGoogle = this.signupGoogle.bind(this);
    this.birthdayWallCheckOnSignup = this.birthdayWallCheckOnSignup.bind(this);
  }

  componentDidMount() {

    window.onkeydown = null;
  }

   
   async signupFB(e){
    e.preventDefault();
    const data = await FBinit.FbLogin();
    if(data.authResponse==null){
      return;
    }
    
    this.props.dispatch(UserActions.FBsignup({accessToken:data.authResponse.accessToken,userID:data.authResponse.userID}, response => {
      
      this.birthdayWallCheckOnSignup(response)
   
      
    }))}
   
   
  async signupGoogle(e){

    e.preventDefault();
    try {
      
    let data = await GoogleInit.SignUpUser();

    this.props.dispatch(UserActions.Googlesignup(data, response => {
      this.birthdayWallCheckOnSignup(response)
    
    }));

    } catch (error) {
      console.error(error);
    }
    
  }
  birthdayWallCheckOnSignup(response) {
    if (response.status) {
      if(response.data.dob=="1000-12-01"){
      
        this.props.history.push('/birthday-wall');
        return;
      }
      this.props.history.push('/');
    } else {
      let error = response.data.message
        ? response.data.message
        : "Something went wrong, try again later!";
      this.setState({showAlert: true, swalParams: {
        title: error,
        type: "error",
        showConfirmButton: false
      }})
      
    }
  }
  changeHandler(e) {
    let newSignupData = Object.assign({}, this.state.signupData);
    newSignupData[e.target.name] = e.target.value;
    this.setState({
      signupData: newSignupData
    }, () => {
      this.checkValidation()
    });

  }
  handlePhoneChange (status, phoneNumber, country){
console.log("handlePhoneChange",country.dialCode);
    let newSignupData = Object.assign({}, this.state.signupData);
    newSignupData['dialCode'] = country.dialCode;
    newSignupData['iso'] = country.iso2;
    newSignupData['phone'] = phoneNumber;
    this.setState({ signupData: newSignupData });
  }
  checkOtp(inputValue) {
    if(User.isLoggedIn()){
    this.setState({ success: false, error: false });
    this.props.dispatch(UserActions.setVerifyOTP({ otp: inputValue}, response => {
      
      if(response.status) {
        this.setState({customClass:"with-close",showAlert: true,swalParams: {
          title: "OTP confirmed successfully",
          type: "success",

          confirmButtonColor:"#007792",
          showConfirmButton: true,
          onConfirm: () => {
            this.setState({show:false,showAlert: false});

            this.props.history.push('/');
          },
          onCancel: () => {
            this.setState({show:false,showAlert:false});
            this.props.history.push('/');
           },
           onOutsideClick: () => {
            this.setState({show:false,showAlert:false});
            this.props.history.push('/');
           },
        }})
      } else {
        this.setState({customClass:"with-close",showAlert: true, swalParams: {
          title: "OTP failed, please try again later!",

          confirmButtonColor:"#007792",
          type: "error",
          showConfirmButton: true,
          onConfirm: () => {
            this.setState({showAlert:false});

            setTimeout(() => this.setState({show: true,customClass:"otp-verification"}), 1000);
            // this.props.history.push('/');
          },
          onCancel: () => {
            this.setState({show:false,showAlert:false});
            this.props.history.push('/');
           },
           onOutsideClick: () => {
            this.setState({show:false,showAlert:false});
            this.props.history.push('/');
           }
        }})
      }
    }))}else{
      console.log("checkOtp:User not logged in");
      swal.showInputError('User is not logged in!');
      return;
    }
  }
  resendOTP(){
    
    if(User.isLoggedIn()){
    const { dispatch } = this.props;
    this.setState({ success: false, error: false });
    dispatch(UserActions.resendVerifyOTP({}, ({ status, data}) => {
      // console.log("resendVerifyOTP",status);
      // console.log("resendVerifyOTP",data);

       if(status){ 
         this.setState({ customClass:"with-close",success: status, error: !status, showAlert: true , swalParams: {
          title: "OTP sent successfully",
          type: "success",
          confirmButtonColor:"#007792",
          showConfirmButton: true,
          onConfirm: () => {
            this.setState({showAlert: false});
            setTimeout(() => this.setState({show: true,customClass:"otp-verification"}), 1000);
            // this.props.history.push('/');
          },
          onCancel: () => {
            this.setState({show:false,showAlert:false});
            this.props.history.push('/');
           },
           onOutsideClick: () => {
            this.setState({show:false,showAlert:false});
            this.props.history.push('/');
           }
        }});}else{
          this.setState({customClass:"with-close",showAlert: true,swalParams: {
            title: "Resend OTP failed, please try again later!",
  
            confirmButtonColor:"#007792",
            type: "error",
            showConfirmButton: true,
            onConfirm: () => {
              this.setState({showAlert:false});
  
              setTimeout(() => this.setState({show: true,customClass:"otp-verification"}), 1000);
              // this.props.history.push('/');
            },
            onCancel: () => {
              this.setState({show:false,showAlert:false});
              this.props.history.push('/');
             },
           onOutsideClick: () => {
            this.setState({show:false,showAlert:false});
            this.props.history.push('/');
           }
          }})
        }


    }));}else{
      console.log("resendOTP:User not logged in");

      swal.showInputError('User is not logged in!');
    }
  }
  checkValidation() {
    let newSignupData = Object.assign({}, this.state.signupData);
    let invalid = true;
    for (let i in newSignupData) {
      console.log(i, newSignupData[i]);
      if (!newSignupData[i]) {
        invalid = true;
        break;
      } else {
        invalid = false;
      }
    }
    console.log("is invalid", invalid, newSignupData);
    this.setState({invalid})
  }
  
  render() {

    const {loading} = this.props;
    const {swalParams, showAlert,customClass} = this.state;
    return (
      <div className="page auth-page signup-page">
        <div className="auth-wrapper">
          <div className="auth-header">
            <h1>Continue to Checkout</h1>
            <p>Sign in to your account or create a new one</p>
          </div>

          <div className="auth-card">
            <div className="auth-tabs">
              <Link to="/signin" className="auth-tab">Sign In</Link>
              <Link to="/signup" className="auth-tab active">Create Account</Link>
            </div>

            <form className="auth-form" onSubmit={this.signup}>
              <div className="auth-row">
                <div className="auth-field">
                  <label htmlFor="firstName">FIRST NAME</label>
                  <input name="firstName" id="firstName" required onChange={this.changeHandler} aria-label="firstName" className="auth-input"/>
                </div>
                <div className="auth-field">
                  <label htmlFor="lastName">LAST NAME</label>
                  <input name="lastName" id="lastName" required onChange={this.changeHandler} aria-label="lastName" className="auth-input"/>
                </div>
              </div>

              <div className="auth-field">
                <label htmlFor="email">EMAIL ADDRESS</label>
                <input type="email" required name="email" id="email" placeholder="Enter your email" onChange={this.changeHandler} aria-label="email" className="auth-input"/>
              </div>

              <div className="auth-row">
                <div className="auth-field">
                  <label htmlFor="mobile">PHONE NUMBER</label>
                  <IntlTelInput
                    containerClassName="intl-tel-input auth-phone-input"
                    inputClassName="auth-input"
                    name="mobile"
                    placeholder="Enter your number"
                    input
                    type="tel"
                    value={this.state.phoneNumber}
                    onPhoneNumberChange={this.handlePhoneChange}
                    aria-label="mobile"
                  />
                </div>
                <div className="auth-field">
                  <label htmlFor="dob">DATE OF BIRTH</label>
                  <input name="dob" id="dob" required type="date" onChange={this.changeHandler} aria-label="dob" className="auth-input"/>
                </div>
              </div>

              <div className="auth-field">
                <label htmlFor="password1">PASSWORD</label>
                <input type="password" required name="password1" id="password1" placeholder="Enter your password" onChange={this.changeHandler} aria-label="password1" className="auth-input"/>
              </div>

              <div className="auth-field">
                <label htmlFor="password2">RE-TYPE PASSWORD</label>
                <input type="password" required name="password2" id="password2" placeholder="Re-enter your password" onChange={this.changeHandler} aria-label="password2" className="auth-input"/>
              </div>

              <div className="auth-helper">
                {this.state.error
                  ? (
                    <div className="auth-error-text">{this.state.error}</div>
                  )
                  : (
                    <div className="auth-helper-text">ALL INFORMATION MUST BE PRESENT TO SIGN UP</div>
                  )}
              </div>

              <button type="submit" disabled={this.state.invalid} className="auth-primary-btn">CREATE ACCOUNT &amp; CONTINUE</button>

              <div className="auth-divider">
                <span>or continue with</span>
              </div>

              <div className="auth-social">
                <GoogleLoginButton className="auth-social-btn google-btn" align={"center"} onClick={(e) => this.signupGoogle(e)}>
                  <span>Sign up with Google</span>
                </GoogleLoginButton>

                <FacebookLoginButton className="auth-social-btn facebook-btn" align={"center"} onClick={(e) => this.signupFB(e)} > <span>Sign up with Facebook</span></FacebookLoginButton>
              </div>

              <div className="auth-switch-link">Already have an account?&nbsp;
                <Link to="/signin" className="bold underlined">Login to proceed</Link>
              </div>
            </form>
          </div>

          <div className="auth-footer-links">
            <Link to="/" className="underlined">Continue Shopping</Link>
          </div>
        </div>
        <Loader visibility={loading} />
        <SweetAlert
          customClass={customClass}
          show={this.state.show}
          title="Phone Verification"
          text="Enter your OTP"
          type="input"
          inputType="number"
          inputPlaceholder="Enter OTP"
          showCancelButton
          confirmButtonColor="#007792"
          cancelButtonText={"Resend"}
          confirmButtonText={'Submit OTP'}
          onOutsideClick={() => this.setState({ show: false })}
          
          onConfirm={(inputValue) => {
            

      
            if (inputValue === undefined || inputValue === null || inputValue === "") {
      swal.showInputError('You need to write something!');
      return;
    }
            this.checkOtp(inputValue);
            return;
          }}
          onEscapeKey={() => this.setState({ show: false })}
          onCancel={
            this.resendOTP
          }
        />
        <SweetAlert customClass={customClass} showCancelButton cancelButtonText={"x"} onCancel={()=> this.setState({showAlert:false})} show={showAlert} onConfirm={() => this.setState({showAlert: false})}  {...swalParams} />
      </div>
    )
  }

  signup(e) {
    e.preventDefault();

    const {
      lastName,
      firstName,
      email,
      phone,
      password1,
      password2,
      dob
    } = this.state.signupData;
    if (password1 != password2) {
      this.setState({error: 'Passowrds do not match'})
    } else {
      let formattedDob = Moment(dob).format("MM/DD/YYYY");
      let ageData = calculateAge(formattedDob);
      if (ageData.status == 0) {
        if (ageData.age < 21) {
          this.setState({error: "Sorry! you are too young"})
        } else {
          this.setState({error: ''});
          let userObj = Object.assign({}, this.state.signupData);
          userObj['name'] = {};
          userObj['name']['first'] = userObj['firstName'];
          userObj['name']['last'] = userObj['lastName'];
          userObj['password'] = userObj['password1'];

          delete userObj['firstName'];
          delete userObj['lastName'];
          delete userObj['password1'];
          delete userObj['password2'];
          console.log("User Data", userObj);
          this.props.dispatch(UserActions.signup(userObj, response => {
            console.log("Signup_response", response);
            if (response.status) {
             this.setState({show:true,customClass:"otp-verification"});

            } else {
              let error;
              if(response.data.error.code == 11000){
                error = 'Data Already Exists';
              }else{
                error= response.data.message
                 ? response.data.message
                 : "Something went wrong, try again!";
              }
              this.setState({customClass:"with-close",showAlert: true, swalParams: {
                title: error,
                type: "error",
                showConfirmButton: false
              }})
              
            }
          }))
        }
      } else {
        this.setState({error: 'date not valid'})
      }

    }

  }
}

export default connect((state) => {
  return {
    loading: state.getIn(['users', 'loading']),
    error: state.getIn(['users', 'error'])
  };
})(SignupPage);



// WEBPACK FOOTER //
// ./src/containers/begin/signup/SignupPage.js